





















































































































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { AuthStoreHelper, CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { addItemToLocalStorage, existItemInList, existKeyInLocalStorage, formatDate, formatList, getDateFormattedAsMoment, getDateFromDateFormatApi, getIndexFromSimpleList, getItemFromLocalStorage, getListWithNewItem, PRIVILEGE_KEYS, PRIVILEGE_TYPES, removeItemFromLocalStorage, StoregeKey, tableSort } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { DriversDialog } from '../components';
import { Driver, DriverToAdd } from '../models/Drivers';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { PageTitle } from '../../core/components';
import { SettingsService } from '../api/SettingsService';
import { Store } from 'vuex';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import { dateTypes } from '../../core/models';

@Component({
    components: { Loading, DriversDialog, PageTitle, Input, SimpleTable }
})
export default class DriversPage extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper) {
    driverToEdit: any = null;
    cancelToken: any | null = null;
    showConfigurationDialog: boolean = false;
    pendingRequest: boolean = false;
    deleteJustOne: boolean = false;
    search: string = '';
    tableFilters: any = {};
    showDriversDialog: boolean = false;
    seeAllDrivers: boolean = false;
    ids: number = 4;
    editing: boolean = false;
    recipientToEdit: Driver | null = null;
    sortBy: string[] = ['name'];
    sortDesc: boolean[] = [false];
    //delete confirmation

    deleteConfirmationTitle: string = 'Eliminar choferes';
    deleteConfirmationMessage: string =
        '¿Está seguro que desea eliminar los choferes seleccionados? Esta acción no se podrá deshacer.';

    showDeleteConfirmationDialog: boolean = false;

    updateAvailableDriversSelected(rows){
        this.selectedItems = rows;
    }

    volverAConfiguracion() {
        this.$router.push(NAME_ROUTES.SETTINGS.path);
    }

    resetFilters() {
        this.search = '';
        this.availabilityFilterValue = 'null';
        removeItemFromLocalStorage(StoregeKey.DRIVERS_LIST_FILTERS);
    }

    saveFilterLocalStorage(key, value) {
        this.tableFilters[key] = value;
        addItemToLocalStorage(StoregeKey.DRIVERS_LIST_FILTERS, this.tableFilters)
    }

    closeDeleteConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.pendingRequest = true;
            this.cancelToken = Axios.CancelToken.source();
            let ids: number[] = [];
            let driversToDelete: string[] = [];
            for (let i = 0; i < this.selectedItems.length; i++) {
                ids.push(this.selectedItems[i].id);
                driversToDelete.push(this.selectedItems[i].name);
            }

            SettingsService.deleteDriverByID(ids, this.cancelToken)
                .then(() => {
                    if (ids.length > 1) {
                        this.$_successDeleteRecipients('Se eliminaron los choferes: ' + driversToDelete.join(', '));
                    } else {
                        this.$_successDeleteRecipients('Se eliminó el chofer: ' + driversToDelete.join(','));
                    }

                    this.pendingRequest = false;
                    this.driversList = this.driversList.filter(x => {
                        return this.selectedItems.indexOf(x) < 0;
                    });
                    this.selectedItems = [];
                })
                .catch(error => {
                    let hasError = error.response.data.message ? error.response.data.message : null;

                    let idWithError: any = null;

                    if (hasError !== null) {
                        idWithError = hasError
                            .match(/\(.*?\)/g)
                            .map(x => x.replace(/[()]/g, ''))
                            .toString();
                    }

                    let driverWithError = this.driversList.filter(item => item.id.toString() === idWithError);

                    if (ids.length > 1) {
                        if (hasError !== null && idWithError !== null) {
                            this.$_errorPatchRecipients(
                                'El Chofer ' +
                                    driverWithError[0].name +
                                    ', está asociado a otra compañía y no se puede eliminar'
                            );
                        } else {
                            this.$_errorPatchRecipients(
                                'No se pudieron eliminar los choferes: ' + driversToDelete.join(', ')
                            );
                        }
                    } else {
                        if (hasError !== null && idWithError !== null) {
                            this.$_errorPatchRecipients(
                                'El Chofer ' +
                                    driversToDelete.join(',') +
                                    ', está asociado a otra compañía y no se puede eliminar'
                            );
                        } else {
                            this.$_errorPatchRecipients(
                                'No se pudo eliminar el chofer: ' + driversToDelete.join(',') + '. Intente nuevamente'
                            );
                        }
                    }
                    this.pendingRequest = false;
                });
        }
        this.showDeleteConfirmationDialog = false;
    }

    addDriver() {
        this.editing = false;
        this.driverToEdit = null;
        this.driversDialog(true);
    }

    editDriver(item) {
        this.editing = true;
        this.driverToEdit = item;
        this.driversDialog(true);
    }

    clearFilter(item) {
        if (item === 'disponibilidad') {
            this.availabilityFilterValue = 'null';
            this.saveFilterLocalStorage('disponibilidad', 'null');
        }
    }

    deleteDriver(item) {
        this.selectedItems = [];
        this.selectedItems.push(item);
        this.showDeleteConfirmationDialog = true;
        this.deleteJustOne = true;
    }
    deleteSelectedItems() {
        this.showDeleteConfirmationDialog = true;
    }

    headers: object[] = [
        {
            text: 'Nombre',
            align: 'center',
            value: 'name'
        },
        {
            text: 'Documento',
            align: 'center',
            value: 'ci'
        },
        {
            text: 'Teléfono',
            align: 'center',
            value: 'phone_number'
        },
        {
            text: 'Fecha de nacimiento',
            align: 'center',
            value: 'date_of_birth',
            formatter: this.parseDate
        },
        {
            text: 'TAG',
            align: 'center',
            value: 'tag'
        },
        {
            text: 'Empresas',
            align: 'left',
            value: 'company',
            formatter: this.formatCompanies
        },
        {
            text: 'Disponible',
            align: 'center',
            value: 'availability',
            filter: this.availabilityFilter
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            sortable: false
        }
    ];
    availabilityFilterValue: string = 'null';

    driversList: any = [];

    availabilityList: any = [
        {
            text: 'Disponible',
            value: 'true'
        },
        {
            text: 'No disponible',
            value: 'false'
        },
        {
            text: 'Todas',
            value: 'null'
        }
    ];

    get isSmartwayMember(){
        return this.$_getSmartwayMember
    }

    formatCompanies(value){
        return formatList(value, 'name');
    }

    parseDate(date: string) {
        if(date == null){
            return '-'
        }
        return getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars, dateTypes.dateYearFormatReverse);
    }

    availabilityFilter(value) {
        if (this.availabilityFilterValue == 'null') {
            return true;
        }
        return value.toString() === this.availabilityFilterValue;
    }

    get shouldCreateDrivers(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.DRIVERS, PRIVILEGE_TYPES.CREATE)
        );
    }

    get shouldEditAndDeleteDrivers(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.DRIVERS, PRIVILEGE_TYPES.EDIT_AND_DELETE)
        );
    }

    get getDrivers() {
        return this.driversList;
    }

    selectedItems: Driver[] = [];

    driversDialog(value) {
        this.showDriversDialog = value;
    }

    closeDriversDialog(action: boolean, driver: any) {
        if (action) {
            this.pendingRequest = true;
            this.getDriversList();
        }
        this.showDriversDialog = false;
        this.editing = false;
    }


    @Watch('$_getSelectedCompany')
    getDriversList() {
        this.pendingRequest = true;
        this.cancelToken = Axios.CancelToken.source();
        this.driversList = [];
        if (this.$_getSelectedCompanyById != null) {
            this.getListOfDrivers()
        }
    }

    getListOfDrivers(){
        this.pendingRequest = true;
        let companyId = this.seeAllDrivers ? null : this.$_getSelectedCompanyById as string;
        SettingsService.getDriversList(companyId, false, this.cancelToken)
        .then(data => {
            this.driversList = data;
            this.pendingRequest = false;
        })
        .catch(err => {
            this.pendingRequest = false;
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron obtener los choferes'
            })

        });
    }

    customSort(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc);
    }

    updateSearchValue(value){
        this.search = value;
    }

    mounted() {
        this.getDriversList();
        if (existKeyInLocalStorage(StoregeKey.DRIVERS_LIST_FILTERS)){
            try {
                this.tableFilters = JSON.parse(getItemFromLocalStorage(StoregeKey.DRIVERS_LIST_FILTERS) || 'null');
                this.availabilityFilterValue =
                    this.tableFilters.disponibilidad !== undefined ? this.tableFilters.disponibilidad : 'null';
            } catch (e) {
                removeItemFromLocalStorage(StoregeKey.DRIVERS_LIST_FILTERS);
            }
        }
    }
}
